import { Phone, MapPin, Clock, X, Globe } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../components/ui/sheet';

const WHATSAPP_NUMBER = "5491156459778";
const INSTAGRAM_URL = "https://www.instagram.com/madererazurita?igsh=OHpieTFiNG5ubDBl";
const WEBSITE_URL = "https://www.maderaszurita.com.ar";
const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/uZ4oDn3NK8ypo1ZAA?g_st=iw";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_mobile-catalog-11/artifacts/piprh87i_Logo%20sin%20fondo%20web%20con%20nombre.png";

const WhatsAppIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
);

const InstagramIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
);

export const InfoSheet = ({ open, onClose }) => {
    const handleClose = () => {
        if (onClose) onClose(false);
    };

    return (
        <Sheet open={open} onOpenChange={handleClose}>
            <SheetContent 
                className="w-full sm:max-w-md flex flex-col p-0 h-full"
                data-testid="info-sheet"
                showCloseButton={false}
            >
                <SheetHeader className="px-4 py-4 border-b border-stone-200 flex-shrink-0">
                    <div className="flex items-center justify-between">
                        <SheetTitle className="text-xl font-bold text-[#007a3f]">
                            Zurita App
                        </SheetTitle>
                        <button
                            onClick={handleClose}
                            className="p-2 hover:bg-stone-100 rounded-full transition-colors"
                            data-testid="close-info-button"
                            aria-label="Cerrar"
                        >
                            <X className="h-5 w-5 text-stone-500" />
                        </button>
                    </div>
                    <SheetDescription className="sr-only">
                        Información de contacto
                    </SheetDescription>
                </SheetHeader>

                <div className="flex-1 overflow-y-auto overscroll-contain p-4 space-y-6" style={{ WebkitOverflowScrolling: 'touch' }}>
                    {/* Contact */}
                    <div>
                        <h3 className="font-semibold text-stone-900 mb-3 flex items-center gap-2">
                            <Phone className="h-4 w-4 text-[#007a3f]" />
                            Contacto
                        </h3>
                        <div className="space-y-3">
                            <a
                                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 p-3 bg-green-50 hover:bg-green-100 rounded-lg transition-colors"
                                data-testid="info-whatsapp"
                            >
                                <div className="bg-green-500 rounded-full p-2">
                                    <WhatsAppIcon className="h-5 w-5 text-white" />
                                </div>
                                <div>
                                    <p className="font-medium text-stone-900">WhatsApp</p>
                                    <p className="text-sm text-stone-500">+54 9 11 5645-9778</p>
                                </div>
                            </a>

                            <a
                                href={INSTAGRAM_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 p-3 bg-pink-50 hover:bg-pink-100 rounded-lg transition-colors"
                                data-testid="info-instagram"
                            >
                                <div className="bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 rounded-full p-2">
                                    <InstagramIcon className="h-5 w-5 text-white" />
                                </div>
                                <div>
                                    <p className="font-medium text-stone-900">Instagram</p>
                                    <p className="text-sm text-stone-500">@madererazurita</p>
                                </div>
                            </a>

                            <a
                                href={WEBSITE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-3 p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors"
                                data-testid="info-website"
                            >
                                <div className="bg-blue-500 rounded-full p-2">
                                    <Globe className="h-5 w-5 text-white" />
                                </div>
                                <div>
                                    <p className="font-medium text-stone-900">Sitio Web</p>
                                    <p className="text-sm text-stone-500">www.maderaszurita.com.ar</p>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* Location */}
                    <div>
                        <h3 className="font-semibold text-stone-900 mb-3 flex items-center gap-2">
                            <MapPin className="h-4 w-4 text-[#007a3f]" />
                            Ubicación
                        </h3>
                        <div className="bg-blue-50 rounded-lg overflow-hidden">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3289.5!2d-58.556!3d-34.445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb11c6a6f4c8d%3A0x0!2sMadero%202707%2C%20San%20Fernando%2C%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1700000000000"
                                width="100%"
                                height="200"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación Maderas Zurita"
                                className="w-full"
                            />
                            <a
                                href={GOOGLE_MAPS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block p-3 hover:bg-blue-100 transition-colors"
                                data-testid="info-location"
                            >
                                <p className="font-medium text-stone-900">Madero 2707</p>
                                <p className="text-sm text-stone-600">Entre Arnoldi y Sarratea</p>
                                <p className="text-sm text-stone-600">San Fernando</p>
                                <p className="text-xs text-blue-600 mt-2 font-medium">Abrir en Google Maps →</p>
                            </a>
                        </div>
                    </div>

                    {/* Hours */}
                    <div className="pb-8">
                        <h3 className="font-semibold text-stone-900 mb-3 flex items-center gap-2">
                            <Clock className="h-4 w-4 text-[#007a3f]" />
                            Horarios de Atención
                        </h3>
                        <div className="bg-stone-100 rounded-lg p-3">
                            <p className="font-medium text-stone-900 mb-2">Lunes a Viernes</p>
                            <div className="space-y-1 text-sm text-stone-600">
                                <p>07:30 a 11:30</p>
                                <p>13:00 a 16:30</p>
                            </div>
                        </div>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
};
